module.exports = __webpack_public_path__ + "static/media/DClogo.c2ca79ad.png";